const skills = [
  { type: "HTML5", level: 95 },
  { type: "CSS3", level: 95 },
  { type: "JavaScript", level: 95 },
  { type: "Bootstrap", level: 90 },
  { type: "SASS", level: 90 },
  { type: "jQuery", level: 90 },
  { type: "Drupal8", level: 80 },
  { type: "ReactJS", level: 80 },
  { type: "React Native", level: 80 },
  { type: "PHP", level: 75 },
  { type: "MySQL", level: 75 },
  { type: "NodeJS", level: 65 },
  { type: "ExpressJS", level: 65 },
  { type: "NoSQL", level: 65 },
  { type: "Java", level: 60 },
  { type: "C", level: 60 },
];

export default skills;
